import { apiConnection } from "@/services/api-connection";
import { notificationManager } from "@/services/utilities/notification-manager";
import { i18n } from "@/i18n";
import { stringManager } from "@/services/utilities/string-manager";
import router from "@/router";
import { loginManager } from "@/services/security/login-manager";
import { studeaManagerStore, trainingCourseStore } from "@/main";
import { messengerMessageManager } from "@/services/messenger-message/messenger-message-manager";
import { formValidator } from "@/services/form/form-validator";
import { formManager } from "@/services/form/form-manager";
import { triadManager } from "@/services/triad/triad-manager";

const URL_MENU = "/app/studea-manager/menu/";
const URL = "/app/studea-manager/";

class StudeaManagerManager {
  STUDEA_MANAGER_TRAINING_DESIGN = "STUDEA_MANAGER_TRAINING_DESIGN";
  STUDEA_MANAGER_WEBLINKS = "STUDEA_MANAGER_WEBLINKS";
  STUDEA_MANAGER_TRIAD_DECLARE_CONTRACT_RUPTURE = "STUDEA_MANAGER_TRIAD_DECLARE_CONTRACT_RUPTURE";
  STUDEA_MANAGER_QUESTIONNAIRES = "STUDEA_MANAGER_QUESTIONNAIRES";
  STUDEA_MANAGER_QUESTIONNAIRES_LOCK = "STUDEA_MANAGER_QUESTIONNAIRES_LOCK";
  STUDEA_MANAGER_QUESTIONNAIRES_SIGN = "STUDEA_MANAGER_QUESTIONNAIRES_SIGN";
  STUDEA_MANAGER_QUESTIONNAIRES_EXPORT = "STUDEA_MANAGER_QUESTIONNAIRES_EXPORT";
  STUDEA_MANAGER_QUESTIONNAIRES_INCIDENT = "STUDEA_MANAGER_QUESTIONNAIRES_INCIDENT";
  STUDEA_MANAGER_DUPLICATE_QUESTIONNAIRE = "STUDEA_MANAGER_DUPLICATE_QUESTIONNAIRE";
  STUDEA_MANAGER_DASHBOARD_NOTE = "STUDEA_MANAGER_DASHBOARD_NOTE";
  STUDEA_MANAGER_TRIAD = "STUDEA_MANAGER_TRIAD";
  STUDEA_MANAGER_TRIAD_IMPORT = "STUDEA_MANAGER_TRIAD_IMPORT";
  STUDEA_MANAGER_TRIAD_LAST_MAIL = "STUDEA_MANAGER_TRIAD_LAST_MAIL";
  STUDEA_MANAGER_TRIAD_CONTRACT_RUPTURE_VALIDATOR = "STUDEA_MANAGER_TRIAD_CONTRACT_RUPTURE_VALIDATOR";
  STUDEA_MANAGER_TRIAD_CONTRACT_RUPTURE_NOTIFY = "STUDEA_MANAGER_TRIAD_CONTRACT_RUPTURE_NOTIFY";
  STUDEA_MANAGER_USER = "STUDEA_MANAGER_USER";
  STUDEA_MANAGER_ALLOWED_TO_SWITCH = "STUDEA_MANAGER_ALLOWED_TO_SWITCH";
  STUDEA_MANAGER_SKILLS = "STUDEA_MANAGER_SKILLS";
  STUDEA_MANAGER_SKILLS_ENTERING = "STUDEA_MANAGER_SKILLS_ENTERING";
  STUDEA_MANAGER_SKILLS_DASHBOARD = "STUDEA_MANAGER_SKILLS_DASHBOARD";
  STUDEA_MANAGER_SKILLS_EXPORT = "STUDEA_MANAGER_SKILLS_EXPORT";
  STUDEA_MANAGER_DUPLICATE_SKILL = "STUDEA_MANAGER_DUPLICATE_SKILL";
  STUDEA_MANAGER_DOCUMENTS_UPLOAD = "STUDEA_MANAGER_DOCUMENTS_UPLOAD";
  STUDEA_MANAGER_DOCUMENTS_GLOBAL = "STUDEA_MANAGER_DOCUMENTS_GLOBAL";
  STUDEA_MANAGER_DOCUMENTS_NOTIFY = "STUDEA_MANAGER_DOCUMENTS_NOTIFY";
  STUDEA_MANAGER_QUALITY_STATS = "STUDEA_MANAGER_QUALITY_STATS";
  STUDEA_MANAGER_HISTORY = "STUDEA_MANAGER_HISTORY";
  STUDEA_MANAGER_ABSENCE = "STUDEA_MANAGER_ABSENCE";
  STUDEA_MANAGER_ABSENCE_ACCESS_DATE = "STUDEA_MANAGER_ABSENCE_ACCESS_DATE";
  STUDEA_MANAGER_ABSENCE_NEW_NOTIFICATION = "STUDEA_MANAGER_ABSENCE_NEW_NOTIFICATION";
  STUDEA_MANAGER_ABSENCE_EXCEEDING = "STUDEA_MANAGER_ABSENCE_EXCEEDING";
  STUDEA_MANAGER_ABSENCE_JUSTIFY_NOTIFICATION = "STUDEA_MANAGER_ABSENCE_JUSTIFY_NOTIFICATION";
  STUDEA_MANAGER_JUSTIFICATION_NOTIFICATION = "STUDEA_MANAGER_JUSTIFICATION_NOTIFICATION";
  STUDEA_MANAGER_SIGNATURE_NOTIFICATION = "STUDEA_MANAGER_SIGNATURE_NOTIFICATION";
  STUDEA_MANAGER_COURSE = "STUDEA_MANAGER_COURSE";
  STUDEA_MANAGER_TEACHERS = "STUDEA_MANAGER_TEACHERS";
  STUDEA_MANAGER_NOTE = "STUDEA_MANAGER_NOTE";
  STUDEA_MANAGER_NOTEPAD = "STUDEA_MANAGER_NOTEPAD";
  STUDEA_MANAGER_REGISTRATION = "STUDEA_MANAGER_REGISTRATION";
  STUDEA_MANAGER_REGISTRATION_IMPORT = "STUDEA_MANAGER_REGISTRATION_IMPORT";
  STUDEA_MANAGER_REGISTRATION_DASHBOARD = "STUDEA_MANAGER_REGISTRATION_DASHBOARD";
  STUDEA_MANAGER_REGISTRATION_SYNC_YPAREO_MANUAL = "STUDEA_MANAGER_REGISTRATION_SYNC_YPAREO_MANUAL";
  STUDEA_MANAGER_REGISTRATION_EXPORT = "STUDEA_MANAGER_REGISTRATION_EXPORT";
  STUDEA_MANAGER_REGISTRATION_NOTIFY_END = "STUDEA_MANAGER_REGISTRATION_NOTIFY_END";
  STUDEA_MANAGER_REGISTRATION_ERROR_NOTIFY = "STUDEA_MANAGER_REGISTRATION_ERROR_NOTIFY";
  STUDEA_MANAGER_REGISTRATION_NOTIFY_QUOTE_VALIDATED = "STUDEA_MANAGER_REGISTRATION_NOTIFY_QUOTE_VALIDATED";
  STUDEA_MANAGER_REGISTRATION_NOTIFY_ADD_MISSION = "STUDEA_MANAGER_REGISTRATION_NOTIFY_ADD_MISSION";
  STUDEA_MANAGER_REGISTRATION_DOWNLOAD_DOCUMENTS = "STUDEA_MANAGER_REGISTRATION_DOWNLOAD_DOCUMENTS";
  STUDEA_MANAGER_REGISTRATION_NOTIFY_NEW = "STUDEA_MANAGER_REGISTRATION_NOTIFY_NEW";
  STUDEA_MANAGER_MESSAGE_MODERATION = "STUDEA_MANAGER_MESSAGE_MODERATION";
  STUDEA_MANAGER_MESSAGE_CONTACT = "STUDEA_MANAGER_MESSAGE_CONTACT";
  STUDEA_MANAGER_MODULE = "STUDEA_MANAGER_MODULE";
  STUDEA_MANAGER_MAIL = "STUDEA_MANAGER_MAIL";
  STUDEA_MANAGER_MAIL_TEMPLATES = "STUDEA_MANAGER_MAIL_TEMPLATES";
  STUDEA_MANAGER_DRIVER_LICENCE = "STUDEA_MANAGER_DRIVER_LICENCE_MANAGEMENT";
  STUDEA_MANAGER_GRADEBOOK = "STUDEA_MANAGER_GRADEBOOK";
  STUDEA_MANAGER_CALENDAR_MANAGEMENT = "STUDEA_MANAGER_CALENDAR_MANAGEMENT";
  STUDEA_MANAGER_SYNCHRONIZE_SIGNATURE = "STUDEA_MANAGER_SYNCHRONIZE_SIGNATURE";
  STUDEA_MANAGER_TIMELINE = "STUDEA_MANAGER_TIMELINE";
  STUDEA_MANAGER_REGISTRATION_FILL_CALENDAR = "STUDEA_MANAGER_REGISTRATION_FILL_CALENDAR";
  STUDEA_MANAGER_UNLOCK_QUESTIONNAIRE = 1;
  STUDEA_MANAGER_SEND_REMINDER = 2;
  STUDEA_MANAGER_DUPLICATION_PENDING = 0;
  STUDEA_MANAGER_DUPLICATION_DONE = 2;
  STUDEA_MANAGER_DUPLICATION_FAILED = 1;
  STUDEA_MANAGER_DUPLICATION_TYPE_TRAINING_COURSE = 0;
  STUDEA_MANAGER_DUPLICATION_TYPE_QUESTIONNAIRE = 1;
  STUDEA_MANAGER_DUPLICATION_TYPE_SKILL = 2;
  STUDEA_MANAGER_DUPLICATION_ACTION_ADD = 1;
  STUDEA_MANAGER_DUPLICATION_ACTION_CRUSH = 2;
  STUDEA_MANAGER_DUPLICATION_ACTION_REPLACE = 3;
  STUDEA_MANAGER_MAXIMUM_QUESTIONNAIRE_DASHBOARD_RATIO = 630;

  getMenu(id) {
    return apiConnection.get(URL_MENU + id, [], true).then((response) => response);
  }

  deleteDocument(id) {
    return new Promise((resolve) => {
      notificationManager
        .showAlert("warning", i18n.global.t("delete_document"), i18n.global.t("document_remove_confirm"), true, true)
        .then((response) => {
          if (response.isConfirmed) {
            apiConnection.delete("/app/studea-manager/document/delete/" + id).then((response) => {
              if (response) {
                notificationManager.showNotification("success", i18n.global.t("document_remove_success"));
              } else {
                notificationManager.showNotification("error", i18n.global.t("document_remove_error"));
              }
              resolve(response);
            });
          }
        });
    });
  }

  remove(alias, trainingCourseId = null, id = null, tradGender = 1, generic = true, subtitle = null) {
    const url =
      URL + (trainingCourseId ? trainingCourseId : "") + (generic ? "/generic" : "") + "/" + alias + "/delete/" + id;

    const tradPrefix = stringManager.toCamelCase(alias);

    return new Promise((resolve) => {
      notificationManager
        .showAlert(
          "error",
          i18n.global.tc("global.delete.title", tradGender, {
            name: i18n.global.tc("studea_manager." + tradPrefix + ".title", 1).toLowerCase(),
          }),
          subtitle
            ? subtitle
            : i18n.global.tc("global.delete.sub_title", tradGender, {
                name: i18n.global.tc("studea_manager." + tradPrefix + ".title", 1).toLowerCase(),
              }),
          true,
          true,
        )
        .then((data) => {
          if (data.isConfirmed) {
            apiConnection.delete(url, {}).then((data) => {
              resolve(data);
              notificationManager.showNotification(
                data.hasError ? "error" : "success",
                data.hasError
                  ? data.detail[0].message
                  : i18n.global.tc("global.delete.success", tradGender, {
                      name: i18n.global.tc("studea_manager." + tradPrefix + ".title", 1),
                    }),
              );
            });
          }
        });
    });
  }

  removePlanningAbsence(trainingCourseId, planningId, alias) {
    const isGeneric = alias === "absence";
    const url = URL + trainingCourseId + (isGeneric ? "/generic" : "") + "/" + alias + "/delete/" + planningId;

    return new Promise((resolve) => {
      apiConnection.delete(url).then((data) => {
        resolve(data);
        notificationManager.showNotification(
          data.hasError ? "error" : "success",
          data.hasError
            ? data.detail[0].message
            : i18n.global.t(alias === "planning" ? "absence.delete_event_success" : "absence.delete_absence_success"),
        );
      });
    });
  }

  removeFromSession(alias, trainingCourseId = null, id = null, tradGender = 1, generic = true, sessionId = null) {
    const url =
      URL +
      (trainingCourseId ? trainingCourseId : "") +
      (generic ? "/generic" : "") +
      "/skill/session/" +
      alias +
      "/" +
      sessionId +
      "/" +
      id;
    let tradPrefix;

    if (alias === "remove-category") {
      tradPrefix = "category";
    } else {
      tradPrefix = "skill";
    }

    return new Promise((resolve) => {
      notificationManager
        .showAlert(
          "error",
          i18n.global.tc("global.delete.title", tradGender, {
            name: i18n.global.tc("studea_manager." + tradPrefix + ".title", 1).toLowerCase(),
          }),
          i18n.global.tc("global.delete.sub_title", tradGender, {
            name: i18n.global.tc("studea_manager." + tradPrefix + ".title", 1).toLowerCase(),
          }),
          true,
          true,
        )
        .then((data) => {
          if (data.isConfirmed) {
            apiConnection.put(url, {}).then((data) => {
              resolve(data);
              notificationManager.showNotification(
                data.hasError ? "error" : "success",
                data.hasError
                  ? data.detail[0].message
                  : i18n.global.tc("global.delete.success", tradGender, {
                      name: i18n.global.tc("studea_manager." + tradPrefix + ".title", 1),
                    }),
              );
            });
          }
        });
    });
  }

  censorMessage(trainingCourseId = null, id = null) {
    const url = URL + (trainingCourseId ? "/" + trainingCourseId : "") + "/message/censor/" + id;

    return new Promise((resolve) => {
      notificationManager
        .showAlert(
          "error",
          i18n.global.t("studea_manager.moderation.alert_title"),
          i18n.global.t("studea_manager.moderation.alert_sub_title"),
          true,
          true,
          i18n.global.t("studea_manager.moderation.censor"),
          i18n.global.t("studea_manager.moderation.restore"),
        )
        .then((data) => {
          apiConnection.put(url, { censor: data.isConfirmed ? 1 : 0 }).then((data) => {
            resolve(data);
            notificationManager.showNotification(
              data.hasError ? "error" : "success",
              data.hasError ? data.detail[0].message : i18n.global.t("studea_manager.moderation.censor_success"),
            );
          });
        });
    });
  }

  removeTriadMember(trainingCourseId, id, profile, userId) {
    const url = URL + trainingCourseId + "/triad/delete-member/" + id + "/" + userId + "/" + profile;

    return new Promise((resolve) => {
      notificationManager
        .showAlert(
          "error",
          i18n.global.tc("global.delete.title", 1, {
            name: i18n.global.tc("studea_manager.triad.delete_member.title", 1).toLowerCase(),
          }),
          i18n.global.tc("global.delete.sub_title", 1, {
            name: i18n.global.tc("studea_manager.triad.delete_member.title", 1).toLowerCase(),
          }),
          true,
          true,
        )
        .then((data) => {
          if (data.isConfirmed) {
            apiConnection.delete(url, {}).then((data) => {
              resolve(data);
              notificationManager.showNotification(
                data.hasError ? "error" : "success",
                data.hasError
                  ? data.detail[0].message
                  : i18n.global.tc("global.delete.success", 1, {
                      name: i18n.global.tc("studea_manager.triad.title", 1),
                    }),
              );
            });
          }
        });
    });
  }

  removeTriadTutors(trainingCourseId, profile) {
    const url = URL + trainingCourseId + "/triad/delete-all-members-type/" + profile;

    return new Promise((resolve) => {
      notificationManager
        .showAlert(
          "error",
          i18n.global.tc("global.delete.title", 3, {
            name: i18n.global
              .tc(
                profile === triadManager.TUTOR_PROFILE
                  ? "studea_manager.triad.delete_all_tutor.title"
                  : "studea_manager.triad.delete_all_map.title",
                1,
              )
              .toLowerCase(),
          }),
          i18n.global.tc("global.delete.sub_title", 3, {
            name: i18n.global
              .tc(
                profile === triadManager.TUTOR_PROFILE
                  ? "studea_manager.triad.delete_all_tutor.title"
                  : "studea_manager.triad.delete_all_map.title",
                1,
              )
              .toLowerCase(),
          }),
          true,
          true,
        )
        .then((data) => {
          if (data.isConfirmed) {
            apiConnection.delete(url, {}).then((data) => {
              resolve(data);
              notificationManager.showNotification(
                data.hasError ? "error" : "success",
                data.hasError
                  ? data.detail[0].message
                  : i18n.global.tc("global.delete.success", 3, {
                      name: i18n.global.tc(
                        profile === triadManager.TUTOR_PROFILE
                          ? "studea_manager.triad.tutor.title"
                          : "studea_manager.triad.map.title",
                        2,
                      ),
                    }),
              );
            });
          }
        });
    });
  }

  getQuestionnaireConfig(trainingCourseId, id = null) {
    return apiConnection
      .get(URL + trainingCourseId + "/questionnaire/form" + (id ? "/" + id : "/add"), [], true)
      .then((response) => response);
  }

  sort(alias, trainingCourseId, id, position, generic = true, type = null) {
    const url = URL + trainingCourseId + "/" + (generic ? "generic/" : "") + alias + "/sort/" + id + "/" + position;
    const tradPrefix = stringManager.toCamelCase(alias);
    let params = {};
    if (type) {
      params["type"] = type;
    }

    return apiConnection.put(url, params).then((response) => {
      if (response) {
        notificationManager.showNotification(
          "success",
          i18n.global.t("global.sort.success", {
            name: i18n.global.tc("studea_manager." + tradPrefix + ".title", 2).toLowerCase(),
          }),
        );
      }
    });
  }

  copy(alias, trainingCourseId, id, tradGender = 1, generic = true, params = {}) {
    const url = URL + trainingCourseId + (generic ? "/generic/" : "/") + alias + "/copy/" + id;
    const tradPrefix = stringManager.toCamelCase(alias);
    return apiConnection.post(url, params).then((response) => {
      if (response) {
        notificationManager.showNotification(
          "success",
          i18n.global.tc("global.copy.success", tradGender, {
            name: i18n.global.tc("studea_manager." + tradPrefix + ".title", 2),
          }),
        );
      }
    });
  }

  editModule(trainingCourseId, id, params = {}) {
    const url = URL + trainingCourseId + "/training-course-module-triad/edit/" + id;
    return apiConnection.put(url, params).then((response) => {
      if (response) {
        notificationManager.showNotification(
          "success",
          i18n.global.t("studea_manager.module." + (params.visible ? "active" : "unactive") + ".success"),
        );
        studeaManagerStore.setModuleVisibility({
          id: id,
          visible: params.visible,
        });
      } else {
        notificationManager.showNotification("error", i18n.global.t("signed_error"));
      }
      studeaManagerStore.fetchStudeaManagerMenu({
        trainingCourseId: trainingCourseId,
        refresh: false,
      });
    });
  }

  move(alias, trainingCourseId, id, dest = null, tradGender = 1, params = {}) {
    const url =
      URL +
      trainingCourseId +
      "/" +
      (alias === "category" ? "questionnaire/category/" : alias + "/") +
      "move/" +
      (dest ? dest + "/" : "") +
      id;
    const tradPrefix = stringManager.toCamelCase(alias);
    return apiConnection.put(url, params).then((response) => {
      if (response) {
        notificationManager.showNotification(
          "success",
          i18n.global.tc("global.move.success", tradGender, {
            name: i18n.global.tc("studea_manager." + tradPrefix + ".title", 2),
          }),
        );
      }
    });
  }

  list(alias, trainingCourseId = null, generic = false, params = {}, triadId = null) {
    return apiConnection
      .get(
        URL +
          (trainingCourseId ? trainingCourseId + "/" : "") +
          (generic ? "generic/" : "") +
          encodeURI(alias) +
          "/list" +
          (triadId ? "/" + triadId : ""),
        params,
      )
      .then((response) => response);
  }

  post(alias, trainingCoursId, generic = false, params = {}, id = null) {
    const url =
      URL + trainingCoursId + "/" + (generic ? "generic/" : "") + encodeURI(alias) + "/post" + (id ? "/" + id : "");
    return apiConnection.post(url, params);
  }

  put(alias, trainingCoursId, generic = false, params = {}, id = null) {
    const url =
      "/app/studea-manager/" +
      trainingCoursId +
      "/" +
      (generic ? "generic/" : "") +
      encodeURI(alias) +
      "/post" +
      (id ? "/" + id : "");
    return apiConnection.put(url, params);
  }

  test(alias, trainingCourseId) {
    return apiConnection
      .get(URL + trainingCourseId + "/" + encodeURI(alias) + "/generate-triad-test")
      .then((response) => response);
  }

  form(alias, trainingCourseId = null, id = null, params = {}, generic = false, search = false, unique = false) {
    return apiConnection
      .get(
        URL +
          (trainingCourseId ? trainingCourseId + "/" : "") +
          (generic ? "generic/" : "") +
          encodeURI(alias) +
          (search ? "/search" : "") +
          "/" +
          (unique ? "unique-" : "") +
          "form" +
          (id ? "/" + id : ""),
        params,
      )
      .then((response) => response);
  }

  importForm(alias, trainingCourseId) {
    return apiConnection
      .get(URL + trainingCourseId + "/" + encodeURI(alias) + "/import-form")
      .then((response) => response);
  }

  sendWelcome(data, trainingCourseId) {
    return apiConnection
      .post(URL + trainingCourseId + "/triad/send-welcome", {
        users: data,
      })
      .then((response) => {
        if (response) {
          notificationManager.showNotification("success", i18n.global.t("studea_manager.triad.send_welcome_email"));
        }
      });
  }

  sendNewPassword(data, trainingCourseId) {
    return apiConnection
      .post(URL + trainingCourseId + "/triad/send-new-password", {
        users: data,
      })
      .then((response) => {
        if (response) {
          notificationManager.showNotification("success", i18n.global.t("studea_manager.triad.send_welcome_email"));
        }
      });
  }

  getLastSendReport(id, trainingCourseId) {
    return apiConnection.get(URL + trainingCourseId + "/triad/last-send-report/" + id).then((response) => response);
  }

  export(alias, trainingCourseId = null, params = {}, id = null) {
    return apiConnection
      .get(
        URL + (trainingCourseId ? trainingCourseId + "/" : "") + encodeURI(alias) + "/export" + (id ? "/" + id : ""),
        params,
      )
      .then((res) => {
        messengerMessageManager.processMessage(res);
      });
  }

  exportAllQuestionnaireRepliesToExcel(trainingCourseId, id) {
    return apiConnection.get(URL + trainingCourseId + "/dashboard/excel-answer/export/" + id).then((res) => {
      messengerMessageManager.processMessage(res);
    });
  }

  isStudeaManager(id) {
    const list = trainingCourseStore.trainingCourseList;
    if (Object.keys(list).length) {
      const trainingCourse = list.find((item) => item.id === parseInt(id));
      if (trainingCourse && trainingCourse.isStudeaManager) {
        return true;
      }
    }
    return false;
  }

  switchUser(id, trainingCourseId, triadId = null) {
    loginManager.storeInitialToken();
    return apiConnection.get("/app/user/" + trainingCourseId + "/switch/" + id).then((response) => {
      if (response.token && response.refreshToken && response.expires) {
        window.sessionStorage.setItem("studea-switchToken", response.token);
        window.sessionStorage.setItem("studea-switchRefreshToken", response.refreshToken);
        window.sessionStorage.setItem("studea-switchExpires", response.expires);
        router.push({
          name: "loginSwitch",
          query: {
            triad: triadId,
          },
        });
      }
    });
  }

  restoreUser() {
    window.localStorage.removeItem("studea-oldTriad");
    window.localStorage.removeItem("studea-oldTrainingCourse");
    const initialToken = window.sessionStorage.getItem("studea-initial-token");
    const initialOldTrainingCourse = window.sessionStorage.getItem("studea-initial-oldTrainingCourse");
    const initialOldTriad = window.sessionStorage.getItem("studea-initial-oldTriad");
    const initialRefreshToken = window.sessionStorage.getItem("studea-initial-refreshToken");
    const initialTokenExpirationDate = window.sessionStorage.getItem("studea-initial-tokenExpirationDate");
    const stayConnected =
      window.localStorage.getItem("studea-stayConnected") &&
      window.localStorage.getItem("studea-stayConnected") === "1";
    if (initialToken && initialRefreshToken) {
      window.sessionStorage.removeItem("studea-initial-token");
      window.sessionStorage.removeItem("studea-initial-refreshToken");
      window.sessionStorage.removeItem("studea-initial-tokenExpirationDate");
      window.sessionStorage.removeItem("studea-switched");

      const data = {
        token: initialToken,
        refresh_token: initialRefreshToken,
        expires: initialTokenExpirationDate,
      };

      loginManager.setToken(data, loginManager.apiPath, stayConnected);

      if (initialOldTrainingCourse) {
        window.localStorage.setItem("studea-oldTrainingCourse", initialOldTrainingCourse);
      }

      if (initialOldTriad) {
        window.localStorage.setItem("studea-oldTriad", initialOldTriad);
      }

      window.sessionStorage.removeItem("studea-initial-oldTrainingCourse");
      window.sessionStorage.removeItem("studea-initial-oldTriad");

      // Rediriger vers la page courante
      router.go(0);
    } else {
      console.error("Jetons initiaux non trouvés. Impossible de restaurer l'utilisateur.");
    }
  }

  toggle(item, name, isMultipleElement) {
    const itemSearch = "." + name + item;
    if (isMultipleElement) {
      for (const row of document.querySelectorAll(itemSearch)) {
        row.classList.toggle("on");
      }
    } else {
      document.querySelector(itemSearch).classList.toggle("on");
    }
  }

  unlockReply(profile, id, triad, trainingCourse) {
    const url = "/app/studea-manager/" + trainingCourse + "/questionnaire/unlock/" + triad + "/" + id;
    return new Promise((resolve) => {
      notificationManager
        .showAlert(
          "question",
          i18n.global.t("studea_manager.dashboard.questionnaire.unlock_questionnaire"),
          i18n.global.t("studea_manager.dashboard.questionnaire.unlocked_confirmation"),
          true,
          true,
        )
        .then((res) => {
          if (res.isConfirmed) {
            apiConnection.get(url, { profile: profile }).then((res) => {
              if (res) {
                resolve(true);
                notificationManager.showNotification(
                  "success",
                  i18n.global.t("studea_manager.dashboard.questionnaire.success_unlock"),
                );
              }
            });
          }
        });
    });
  }

  unlockAllReplies(id, trainingCourseId) {
    return new Promise((resolve) => {
      const url = URL + trainingCourseId + "/unlock-all/" + id;
      notificationManager
        .showAlert(
          "question",
          i18n.global.t("studea_manager.dashboard.questionnaire.unlock_all_questionnaires"),
          i18n.global.t("studea_manager.dashboard.questionnaire.unlocked_confirmation"),
          true,
          true,
        )
        .then((res) => {
          if (res.isConfirmed) {
            apiConnection.get(url, {}).then((res) => {
              if (res) {
                resolve(true);
                notificationManager.showNotification(
                  "success",
                  i18n.global.t("studea_manager.dashboard.questionnaire.success_all_unlock"),
                );
              }
            });
          }
        });
    });
  }

  sendOneEmailReminder(data, trainingCourseId) {
    notificationManager
      .showAlert(
        "question",
        i18n.global.t("studea_manager.dashboard.questionnaire.send_email_reminder"),
        i18n.global.t("studea_manager.dashboard.questionnaire.send_email_reminder_confirmation"),
        true,
        true,
        i18n.global.t("send"),
      )
      .then((response) => {
        if (response.isConfirmed) {
          studeaManagerManager.post("questionnaire/email-reminder", trainingCourseId, false, data).then((res) => {
            if (res.success) {
              notificationManager.showNotification(
                "success",
                i18n.global.tc("studea_manager.dashboard.questionnaire.send_email_reminder_success", 1),
              );
            }
          });
        }
      });
  }

  getDashboardData(trainingCourse, params) {
    return apiConnection.get(URL + trainingCourse + "/dashboard", params);
  }

  getDashboardMarkData(trainingCourse, params) {
    return apiConnection.get(URL + trainingCourse + "/dashboard-mark", params);
  }

  getDuplicationForm(code) {
    return apiConnection.get(URL + "duplication/" + code + "/form");
  }

  postDuplicationForm(code, data) {
    return apiConnection.post(URL + "duplication/" + code + "/post", data);
  }

  getReferentialList(trainingCourseId) {
    return apiConnection.get(URL + trainingCourseId + "/skill/referentials").then((response) => response);
  }

  getReferentialSessionForm(trainingCourseId) {
    return apiConnection.get(URL + trainingCourseId + "/skill/referentials/session/form").then((response) => response);
  }

  postReferentialSession(trainingCourseId, sessionId, data) {
    return apiConnection
      .post(URL + trainingCourseId + "/skill/post-referential-session/" + sessionId, data)
      .then((response) => response);
  }

  getStatistic() {
    return apiConnection.get(URL + "statistic/list").then((response) => response);
  }

  exportTriads = (trainingCourseId) => {
    return apiConnection.get(URL + trainingCourseId + "/triad/export-all").then((res) => {
      messengerMessageManager.processMessage(res);
    });
  };

  getMail(id, trainingCourseId) {
    return apiConnection.get("/app/studea-manager/" + trainingCourseId + "/mail/" + id).then((response) => response);
  }

  getStudeaManagerSkillConfig(trainingCourse) {
    return apiConnection.get("/app/studea-manager/" + trainingCourse + "/skill/config").then((response) => response);
  }

  exportStatistic(route = "") {
    return apiConnection.get(URL + "statistic" + route).then((res) => {
      messengerMessageManager.processMessage(res);
    });
  }

  eduSignSynchronize(trainingCourseId, planning = false) {
    const title = planning
      ? i18n.global.t("edusign.get_data.confirmation")
      : i18n.global.t("edusign.synchronize.confirmation");
    const url =
      "/app/studea-manager/" +
      trainingCourseId +
      "/edusign/synchronize-" +
      (planning ? "plannings-" : "") +
      "by-training-course";

    notificationManager.showAlert("question", title, "", true, true).then((res) => {
      if (res.isConfirmed) {
        apiConnection.get(url).then((res) => {
          messengerMessageManager.processMessage(res);
        });
      }
    });
  }

  uniserviceSynchronize(trainingCourseId, id = null) {
    const title = i18n.global.t("uniservice.get_data.confirmation");
    let url = URL + trainingCourseId + "/uniservice/synchronize-by-training-course";
    if (id) {
      url += "/" + id;
    }

    notificationManager.showAlert("question", title, "", true, true).then((res) => {
      if (res.isConfirmed) {
        apiConnection.get(url).then((res) => {
          messengerMessageManager.processMessage(res);
        });
      }
    });
  }

  uniserviceReset(trainingCourseId) {
    const title = i18n.global.t("uniservice.reset.confirmation");
    const url = URL + trainingCourseId + "/uniservice/reset-by-training-course";

    notificationManager.showAlert("question", title, "", true, true).then((res) => {
      if (res.isConfirmed) {
        return apiConnection.get(url).then((res) => res);
      }
    });
  }

  getDuplicationsHistoric(params = {}) {
    return apiConnection.get(URL + "duplication/historic/list", params).then((res) => res);
  }

  getDuplicationsHistoricFilterForm() {
    return apiConnection.get(URL + "duplication/historic/search/form").then((res) => res);
  }

  getOneDuplicationHistoric(id) {
    return apiConnection.get(URL + "duplication/historic/" + id).then((res) => res);
  }

  managerSubject(trainingCourseId, data, id) {
    const url = URL + trainingCourseId + "/generic/subject/post" + (id ? "/" + id : "");
    if (id) {
      return apiConnection.put(url, data).then((res) => res);
    } else {
      return apiConnection.post(url, data).then((res) => res);
    }
  }

  searchFormerUser(email, trainingCourseId) {
    return apiConnection.get(URL + trainingCourseId + "/teacher/" + email).then((res) => res);
  }

  addFormer(trainingCourseId, formerId = null, models) {
    const errors = formValidator.validForm(models);
    if (errors.length) {
      return { hasError: true, errors };
    }

    const result = formManager.processForm(models);
    result["user"] = { id: formerId };

    return apiConnection
      .post(URL + trainingCourseId + "/teacher/post" + (formerId ? "/" + formerId : ""), result)
      .then((response) => response);
  }

  getGradeBookSessionList(trainingCourse) {
    return apiConnection.get(URL + trainingCourse + "/gradebook/config/list").then((res) => res);
  }

  deleteGradebookElement(trainingCourse, id, type = null) {
    return apiConnection
      .delete(URL + trainingCourse + "/gradebook/config/session/" + (type ? type + "/" : "") + id)
      .then((res) => res);
  }

  deleteGradebookExam(trainingCourse, id) {
    return apiConnection.delete(URL + trainingCourse + "/gradebook/config/exam/" + id).then((res) => res);
  }

  putGradebookElement(trainingCourse, id, result, type = null) {
    return apiConnection
      .put(URL + trainingCourse + "/gradebook/config/" + (type ? type + "/" : "") + "put/" + id, result)
      .then((res) => res);
  }

  getGradebookExamForm(trainingCourseId, sessionId, id = null) {
    return apiConnection
      .get(
        URL +
          trainingCourseId +
          "/gradebook/config/session" +
          (sessionId ? "/" + sessionId : "") +
          "/exam/form" +
          (id ? "/" + id : ""),
      )
      .then((res) => res);
  }

  getGradebookSubjectForm(trainingCourseId, examId, id = null) {
    return apiConnection
      .get(
        URL +
          trainingCourseId +
          "/gradebook/config/session/exam" +
          (examId ? "/" + examId : "") +
          "/subject/form" +
          (id ? "/" + id : ""),
      )
      .then((res) => res);
  }

  getEditGradebookSubjectList(trainingCourseId, sessionId) {
    return apiConnection
      .get(URL + trainingCourseId + "/gradebook/edit/session/" + sessionId + "/subject/list")
      .then((res) => res);
  }

  getGradeboodExamMarkList(examId, trainingCourseId) {
    return apiConnection
      .get(URL + trainingCourseId + "/gradebook/edit/subject/exam/" + examId + "/mark/list")
      .then((res) => res);
  }

  getGradebookData(trainingCourseId, sessionId) {
    return apiConnection
      .get(URL + trainingCourseId + "/gradebook/session/" + sessionId + "/triad/list")
      .then((res) => res);
  }

  getEditGradeboodSubjectMarkList(trainingCourseId, subjectId) {
    return apiConnection
      .get(URL + trainingCourseId + "/gradebook/session/subject/" + subjectId + "/mark/list")
      .then((res) => res);
  }

  saveGradebookExamPercentage(trainingCourseId, subjectId, percentage) {
    return apiConnection
      .put(
        URL + trainingCourseId + "/gradebook/config/session/subject/" + subjectId + "/exam/percentage/put",
        percentage,
      )
      .then((res) => {
        return res;
      });
  }

  saveGradebookMark(trainingCourseId, subjectId, gradebookNoteId, result) {
    return apiConnection
      .put(URL + trainingCourseId + "/gradebook/edit/subject/" + subjectId + "/mark/put/" + gradebookNoteId, result)
      .then((res) => res);
  }

  unlockGradebookNote(trainingCourseId, gradebookNoteId) {
    return apiConnection
      .get(URL + trainingCourseId + "/gradebook/edit/mark/unlock/" + gradebookNoteId)
      .then((res) => res);
  }

  getExamList(trainingCourseId, sessionId) {
    return apiConnection.get(URL + trainingCourseId + "/gradebook/session/" + sessionId + "/exam").then((res) => res);
  }

  exportGradebookToExcel(trainingCourseId, sessionId) {
    return apiConnection
      .get(URL + trainingCourseId + "/gradebook/export/excel/session/" + sessionId)
      .then((res) => res);
  }

  exportGradebookToPdf(trainingCourseId, sessionId, triadId) {
    return apiConnection
      .get(URL + trainingCourseId + "/gradebook/export/pdf/session/" + sessionId + "/triad/" + triadId)
      .then((res) => res);
  }

  saveGradebookComment(trainingCourseId, sessionId, triadId, comment) {
    return apiConnection
      .put(URL + trainingCourseId + "/gradebook/session/" + sessionId + "/triad/" + triadId + "/comment", comment)
      .then((res) => res);
  }

  validGradebookSession(trainingCourseId, sessionId, data) {
    switch (data.valid) {
      case true:
        return apiConnection
          .put(URL + trainingCourseId + "/gradebook/edit/session/" + sessionId + "/validate", data.data)
          .then((res) => res);
      case false:
        return apiConnection
          .put(URL + trainingCourseId + "/gradebook/edit/session/" + sessionId + "/deviate")
          .then((res) => res);
    }
  }

  getAttendanceCertificate(trainingCourseId, params) {
    return apiConnection.get(URL + trainingCourseId + "/attendance-certificate/list", params).then((res) => res);
  }

  getAttendanceCertificateSearchForm(trainingCourseId) {
    return apiConnection.get(URL + trainingCourseId + "/attendance-certificate/search/form").then((res) => res);
  }

  deleteTimelineItem(trainingCourseId, id) {
    return apiConnection.delete(URL + trainingCourseId + "/dashboard/delete/timeline/" + id).then((res) => res);
  }

  active(alias, id) {
    return apiConnection.put(URL + alias + "/switch/" + id).then((res) => res);
  }

  getContractForm(trainingCourseId, triadId, contractId) {
    return apiConnection
      .get(URL + trainingCourseId + "/contract/triad/" + triadId + "/form" + (contractId ? "/" + contractId : ""))
      .then((res) => res);
  }

  putChangeFormerForm(trainingCourseId, data) {
    return apiConnection.put(URL + trainingCourseId + "/planning/change-former/put", data).then((res) => res);
  }

  async cancelContractRupture(trainingCourseId, contractId) {
    return await apiConnection.put(URL + trainingCourseId + "/contract/rupture/put/reinit/" + contractId);
  }

  async cancelTrainingCourseDroppedOut(trainingCourseId, triadId) {
    return await apiConnection.put(URL + trainingCourseId + "/dropped-out/put/reinit/" + triadId);
  }
}

export const studeaManagerManager = new StudeaManagerManager();
